import { CommonActionType } from './action.type';

export const CommonMutations = {
    [CommonActionType.SetExchangeRate](state, rate) {
        state.rate = rate;
    },

    [CommonActionType.SetMinFeeBuy](state, minFeeBuy) {
        state.minFeeBuy = minFeeBuy;
    },

    [CommonActionType.FeeBuyPro](state, feeBuyPro) {
        state.feeBuyPro = feeBuyPro;
    },

    [CommonActionType.SetCustomerLevels](state, customerLevels) {
        state.customerLevels = customerLevels;
    },

    [CommonActionType.SetWarehouse](state, warehouse) {
        state.warehouse = warehouse;
    },

    [CommonActionType.SetChinaStore](state, chinaStore) {
        state.chinaStore = chinaStore;
    },
    
    [CommonActionType.SetFeeGuarantee](state, feeGuarantee) {
        state.feeGuarantee = feeGuarantee;
    },

    [CommonActionType.SetSafeLevel](state, safeLevel) {
        state.safeLevel = safeLevel;
    },

    [CommonActionType.ShowHideMenuLeft](state, isShowHideMenuLeft) {
        state.showMenuLeft = isShowHideMenuLeft;
    },

    [CommonActionType.SetConfiguration](state, configuration) {
        state.configuration = configuration;
    },

    [CommonActionType.SetAvailableVoucher](state, data) {
        state.availableVouchers = data;
    },

    setFilters(state, { filter }) {
        state.filters = filter;
    },
    setFilterConditions(state, { filter }){
        state.filterConditions = filter;
    },
};
